import React from "react";
import { useStoreModel } from "../storeModel";
import { SearchTypeEnum } from "@components/YhPageHeader/Types";
import { YhPageHeader } from "@components/YhPageHeader";
import { StatusDs } from "@src/types/FmsDs";


export function PageHeader() {
    const {
        searchParam,
        orgDs,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
    } = useStoreModel();

    const searchFields = [

        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "分支编码",
            fieldName: "branch",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "从属机构",
            fieldName: "orgCode",
            size: "small",
            disabled: false,
            treeDs: orgDs
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "关联实体",
        //     fieldName: "beCode",
        //     size: "small",
        //     disabled: false,
        //     options: []
        // },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "门店名称",
            fieldName: "name",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: StatusDs
        },

    ]

    return (
        <YhPageHeader
            title="门店管理"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}